export enum TabsStepsEnum {
  INVESTMENT = 'investment',
  COSTS = 'costs',
  EMISSIONS = 'emissions'
}
